<template>
  <b-modal size="xl" class="modal" title="Balance"  v-model="localVisible" hide-footer @hide="closeModal" >
    <b-table :fields="fields" :items="items">

    </b-table>
  </b-modal>
</template>


<script >
import Table from "@/components/Common/Table.vue";
import {CurrencyAmountFormat} from "@core/utils/CurrencyAmountFormat";

export default {
  name:'BalanceModal',
  components: {Table},
  props:{
    isVisible:Boolean,
    data:Object,
  },
  data(){
    return{
      localVisible:this.isVisible,
      items:[],
      currencies:[],
      fields: [
        { key: "currency", label: "Currency" },
        { key: "saldo", label: "Saldo Amount" },
        { key: "amount_of_sold_invoices", label: "Amount of Sold Invoices"},
        { key: "amount_of_settled_invoices", label: "Amount of Settled Invoices"},
        { key: "refund_sum", label: "Sum of Refunds"},
        { key: "refund_default_sum", label: "Sum of Default Refunds"},
      ],
    }
  },
  watch:{
    isVisible(val){this.localVisible =val}
  },

  methods:{
    closeModal(){
      this.localVisible = false;
      this.$emit('update:isVisible', false)
    },
    amountFormat(amount, currency) {
      return CurrencyAmountFormat(amount, currency)
    },
    setTableData() {
      this.$http.post(`/company/admin/seller-modal-info/${this.data.id}`).then((response) => {
        if (response.status == 200) {
          response.data.value.map((item) => {
            this.items.push({
              currency:item.currency,
              saldo: this.amountFormat(item.saldo,item.currency),
              amount_of_sold_invoices: this.amountFormat(item.amount_of_sold_invoices, item.currency),
              amount_of_settled_invoices: this.amountFormat(item.amount_of_settled_invoices, item.currency),
              refund_sum: this.amountFormat(item.refund_sum, item.currency),
              refund_default_sum: this.amountFormat(item.refund_default_sum, item.currency)
            })
          })

        }
      });
    },
  },
  created() {
    this.setTableData()
  },

}
</script>

<style scoped>

</style>